// Lightweight i18n: English / Hindi / Gujarati
// Add new keys at the bottom; missing keys fall back to English.

export const TRANSLATIONS = {
  en: {
    // Nav
    home: "Home",
    services: "Services",
    book: "Book",
    bookAppointment: "Book Appointment",
    shop: "Shop",
    signIn: "Sign In",
    signOut: "Logout",
    account: "Account",
    admin: "Admin",
    salesPanel: "Sales Panel",
    retargeting: "Retargeting",
    bulkMessage: "Bulk Message",
    cart: "Cart",
    // Announcements
    annFreeShip: "Free shipping across India over ₹999",
    annTrusted: "Trusted by 8,000+ Barodians",
    annBookOnline: "Book online · Walk-ins welcome",
    annOff: "20% off on your first visit",
    // Hero
    heroOverline: "Eminence · Vadodara · Since 2019",
    heroTitleA: "Premium Hair Extensions",
    heroTitleB: "Designed for you.",
    heroSub: "Editorial cuts. Masterful colour. Curated beauty — crafted for you in the heart of Alkapuri.",
    shopNow: "Shop Now",
    scroll: "Scroll",
    // Sections
    findYourMoment: "Find your moment",
    chooseRitual: "Choose your ritual",
    catHair: "Hair Styling",
    catSkin: "Skin & Facials",
    catBridal: "Bridal Looks",
    catSpa: "Spa & Wellness",
    explore: "Explore →",
    ourAtelier: "Our Atelier",
    quietLuxA: "Quiet luxury,",
    quietLuxB: "delivered with care.",
    quietLuxBody: "Every chair is private. Every appointment unhurried. Trained across London, Mumbai and Tokyo — our team brings global mastery to Vadodara.",
    exploreAll: "Explore all services",
    bestSellers: "Eminence Best Sellers",
    bestSellersSub: "Salon-grade beauty essentials, curated by our team.",
    viewAllProducts: "View All Products",
    signatureServices: "Signature Services",
    craftedForYou: "Crafted, just for you.",
    trustedByYou: "Trusted by women like you",
    // Trust badges
    trustEasyBooking: "Easy Booking",
    trustEasyBookingSub: "Confirm online in 60 seconds",
    trustWorldwide: "Worldwide Products",
    trustWorldwideSub: "Shipped across India",
    trustWA: "WhatsApp Support",
    trustWASub: "Get expert assistance",
    trustSince: "Trusted Since 2019",
    trustSinceSub: "8,000+ happy clients",
    // Why Eminence
    whyOverline: "Why Eminence Exists",
    whyTitle: "Beauty done well — without the rush.",
    whyP1: "Designed to solve real beauty concerns, not paper over them.",
    whyP2: "Crafted for all-day comfort — confidence that lasts the day.",
    whyP3: "Made with ethically sourced products, hand-selected for quality.",
    whyP4: "For women who value dignity, time, and natural beauty.",
    ourValues: "Our values",
    // Forms / Login
    welcome: "Welcome",
    signInTitle: "Sign in",
    email: "Email",
    password: "Password",
    newToEminence: "New to Eminence?",
    createAccount: "Create account",
    haveAccount: "Have an account?",
    fullName: "Full name",
    productName: "Product name",
    phone: "Phone",
    // Booking
    reserve: "Reserve",
    bookYourAppointment: "Book your appointment",
    service: "Service",
    stylist: "Stylist (optional)",
    anyAvailable: "Any available",
    selectService: "Select a service —",
    date: "Date",
    time: "Time",
    notes: "Notes (optional)",
    summary: "Summary",
    duration: "Duration",
    total: "Total",
    confirmBooking: "Confirm Booking",
    confirming: "Confirming…",
    payAtSalon: "Pay at salon. Cancellation free up to 4 hours before.",
    // Shop / Cart
    apothecary: "Apothecary",
    eminenceShop: "The Eminence Shop",
    shopSub: "Salon-grade beauty essentials, curated by our team for everyday luxury.",
    searchProducts: "Search products…",
    noProducts: "No products found.",
    quickBuy: "Quick Buy",
    addToCart: "Add to cart",
    yourBag: "Your bag",
    nothingHere: "Nothing here yet.",
    browseShop: "Browse the shop",
    subtotal: "Subtotal",
    shipping: "Shipping",
    free: "Free",
    checkout: "Checkout",
    placeOrder: "Place Order",
    placing: "Placing…",
    // Dashboard
    accountWelcome: "Welcome",
    manageAppts: "Manage appointments, orders, and details.",
    bookings: "Bookings",
    orders: "Orders",
    profile: "Profile",
    noBookings: "No bookings yet.",
    noOrders: "No orders yet.",
    // Footer
    explore_label: "Explore",
    visit: "Visit",
    hours: "Hours",
    customerCare: "Customer Care",
    return14: "14-Day easy return on products",
    // Experience Centers
    ourLocations: "Our Locations",
    expCenters: "Eminence Experience Centers",
    expCentersSub: "Visit us in-person for a personalized consultation with our expert stylists.",
    getDirections: "Get Directions",
    contact: "Contact",
    whatsapp: "WhatsApp",
    experienceCenter: "Experience Center",
    // Landing Page
    tagline: "10+ Years of Craft · Hair · Skin · Bridal · Spa · Curated Apothecary ·",
    ourCollection: "Our Collection",
    exploreCollection: "Explore the Collection",
    bestSeller: "Best Seller",
    quickView: "Quick View",
    viewCollection: "View Collection",
    clientExp: "Client Experiences",
    whatTheySay: "What They Say About Eminence",
    commonQueries: "Common Queries",
    frequentlyAsked: "Frequently Asked Questions",
    // FAQ
    faq1q: "How can I book an appointment?",
    faq1a: "You can book directly via our 'Book Appointment' button in the header, or message us on WhatsApp for instant confirmation.",
    faq2q: "What types of hair extensions do you specialize in?",
    faq2a: "We specialize in 100% human hair extensions including Clip-ins, Buns, Side Patches, and permanent extensions curated by our experts.",
    faq3q: "Do you offer bridal and event styling?",
    faq3a: "Yes, we have dedicated bridal suites and senior artists specialized in high-end bridal transformations and event styling.",
    faq4q: "Is there a loyalty program?",
    faq4a: "Absolutely! Every purchase and service at Eminence earns you loyalty points that can be redeemed for future bookings and apothecary products.",
    faq5q: "Where are your experience centers located?",
    faq5a: "We are currently located in major hubs across Vadodara. You can find our exact locations in the 'Experience Centers' section above.",
    // Product Detail
    specifications: "Specifications",
    shippingReturns: "Shipping & Returns",
    description: "Description",
    material: "Material",
    style: "Style",
    durability: "Durability",
    premiumHair: "100% Premium Human Hair",
    salonFinish: "Salon-Grade Finish",
    longLasting: "Long-lasting with proper care",
    freeShipIndia: "Enjoy free shipping across India on orders over ₹999. Our standard delivery time is 3-5 business days.",
    hygienePolicy: "For hygiene reasons, hair extensions are eligible for returns only if the seal remains unbroken and the packaging is in its original condition.",
    guestReviews: "Guest Reviews",
    writeReview: "Write a Review",
    rating: "Rating",
    comment: "Comment",
    postReview: "Post Review",
    posting: "Posting...",
    noReviews: "No reviews yet. Be the first to share your experience.",
    mrp: "MRP",
    qty: "Qty",
    units: "units",
    stock: "Stock",
    delivery: "Delivery",
    selectColor: "Select Color",
    // Services
    servicesRituals: "Services & Rituals",
    servicesSub: "From precision cuts to bridal moments — every service tailored to you.",
    theTeam: "The Team",
    ourArtisans: "Our Artisans",
    portfolioGallery: "Portfolio Gallery",
    portfolioSoon: "Portfolio coming soon…",
    min: "min",
    from: "From",
    // Checkout
    orderPlaced: "Order Placed!",
    orderConfirmed: "Thank you, {name}. Your order #{id} is confirmed.",
    downloadInvoice: "Download Invoice",
    viewOrders: "View My Orders",
    finalTouch: "Final touch",
    address: "Street address",
    city: "City",
    pincode: "Pincode",
    loyaltyRewards: "Loyalty Points Rewards",
    currentBalance: "Current Balance:",
    points: "points",
    worth: "Worth",
    shopToEarn: "Shop to earn more!",
    loginToUsePoints: "Login to use your points",
    pointsApplied: "Points Applied",
    usePoints: "Use Points",
    noPoints: "No points available",
    codNotice: "Payment on delivery (COD). All prices include taxes.",
    orderSummary: "Order Summary",
    pointsDiscount: "Points Discount",
    pointsEarned: "Points earned on this order",
    // Dashboard
    yourLoyalty: "Your Loyalty Points",
    pointsUsed: "Points Used",
    pointsEarnedShort: "Points Earned",
    invoice: "Invoice",
    role: "Role",
    currentPoints: "Current Points",
    notProvided: "Not provided",
    order: "Order",
    // Admin
    operations: "Operations",
    adminDashboard: "Admin Dashboard",
    adminSub: "Manage Eminence end-to-end.",
    overview: "Overview",
    enquiries: "Enquiries",
    users: "Users",
    customer: "Customer",
    status: "Status",
    category: "Category",
    stock_label: "Volume",
    mainImg: "Main Image URL",
    videoUrl: "Video URL",
    extraImages: "Additional Images (comma separated)",
    client: "Client",
    concern: "Concern",
    joined: "Joined",
    revenue: "Revenue",
    recentOrders: "Recent Orders",
    noRecords: "No records.",
    edit: "Edit",
    add: "Add",
    create: "Create",
    update: "Update",
    deleteConfirm: "Delete?",
    deleted: "Deleted",
    saveFailed: "Save failed",
    product: "Product",
    // Footer
    footerPitch: "A premium salon and curated beauty store. Modern technique with the warmth of Indian hospitality.",
    shopProducts: "Shop Products",
    myAccount: "My Account",
    weekdays: "Mon — Sat · 10:00 – 21:00",
    sunday: "Sunday · 11:00 – 19:00",
    rights: "© 2026 Eminence Salon Vadodara. All rights reserved.",
    buildBy: "build by",
    all: "All",
    chooseServiceError: "Please choose service, date and time.",
    bookSuccess: "Appointment confirmed.",
    notesPlaceholder: "Allergies, preferences, occasion…",
    welcomeBack: "Welcome back, {name}.",
    demoCreds: "Demo credentials",
    joinEminence: "Join Eminence",
    regSuccess: "Account created successfully!",
    mensSection: "The Modern Man",
    mensGrooming: "Men's Grooming",
    hairSystems: "Hair Systems",
    mensShop: "Shop for Men",
    mensGroomingSub: "Precision cuts, beard styling, and non-surgical hair restoration.",
    men: "Men",
    women: "Women",
    accessories: "Accessories",
    accessoriesSection: "Complete Your Look",
    accessoriesShop: "Shop Accessories",
    accessoriesSub: "Elevate your style with our premium range of hair accessories and care essentials.",
    targetAudience: "Target Audience",
    essentials: "Essentials",
    // Men Page
    menPageHeroOverline: "Non-Surgical Hair Replacement",
    menPageHeroTitle: "Confidence Restored.",
    menPageHeroSub: "Premium hair systems designed for the modern man. Undetectable, durable, and crafted for a completely natural look.",
    menWhyTitle: "Why Choose Eminence Hair Systems?",
    menWhySub: "We don't just provide hair patches; we provide a new outlook on life.",
    menFeature1Title: "100% Human Hair",
    menFeature1Sub: "Highest quality natural hair for perfect texture and movement.",
    menFeature2Title: "Undetectable Base",
    menFeature2Sub: "Ultra-thin materials that blend seamlessly with your scalp.",
    menFeature3Title: "Active Lifestyle",
    menFeature3Sub: "Swim, gym, and shower with total confidence.",
    menSystemsTitle: "Our Hair Systems",
    menSystemLaceTitle: "French Lace System",
    menSystemLaceSub: "The most breathable and natural-looking base, perfect for hot climates.",
    menSystemSilkTitle: "Silk Top System",
    menSystemSilkSub: "The most realistic 'scalp' appearance. Hair looks like it's growing from your head.",
    menSystemMonoTitle: "Monofilament System",
    menSystemMonoSub: "The most durable option, designed for long-lasting wear and easy maintenance.",
    menProcessTitle: "The Transformation Journey",
    menStep1Title: "Consultation",
    menStep1Sub: "We analyze your hair loss pattern and scalp type.",
    menStep2Title: "Custom Mapping",
    menStep2Sub: "Precise measurements to ensure a perfect fit and natural hairline.",
    menStep3Title: "Fitting & Styling",
    menStep3Sub: "Our master stylists cut and blend the system to your face shape.",
    menStep4Title: "Final Look",
    menStep4Sub: "Walk out with a full head of hair and a new boost of confidence.",
    menFaqTitle: "Common Questions",
    menFaq1Q: "Can I shower or swim with a hair patch?",
    menFaq1A: "Yes! Our high-quality adhesives are water-resistant. You can maintain your active lifestyle with ease.",
    menFaq2Q: "How long does a hair system last?",
    menFaq2A: "Depending on the base material and maintenance, systems typically last 3 to 8 months.",
    menFaq3Q: "Will people be able to tell I'm wearing one?",
    menFaq3A: "Not at all. Our specialized techniques ensure the hairline is completely undetectable.",
  },
  hi: {
    home: "होम",
    services: "सेवाएँ",
    book: "बुक करें",
    bookAppointment: "अपॉइंटमेंट बुक करें",
    shop: "शॉप",
    signIn: "साइन इन",
    signOut: "लॉगआउट",
    account: "मेरा खाता",
    admin: "एडमिन",
    salesPanel: "सेल्स पैनल",
    retargeting: "रिटारगेटिंग",
    bulkMessage: "बल्क मैसेज",
    cart: "कार्ट",
    annFreeShip: "₹999 से ऊपर पूरे भारत में मुफ्त शिपिंग",
    annTrusted: "8,000+ बड़ौदावासियों का भरोसा",
    annBookOnline: "ऑनलाइन बुक करें · वॉक-इन भी स्वागत है",
    annOff: "पहली विज़िट पर 20% की छूट",
    heroOverline: "एमिनेंस · वडोदरा · 2019 से",
    heroTitleA: "एक सैलून उन महिलाओं के लिए",
    heroTitleB: "जो समझौता नहीं करतीं।",
    heroSub: "एडिटोरियल कट्स। मास्टर कलर। क्यूरेटेड ब्यूटी — आपके लिए, अल्कापुरी के दिल से।",
    shopNow: "अभी ख़रीदें",
    scroll: "स्क्रॉल",
    findYourMoment: "अपना पल खोजें",
    chooseRitual: "अपनी पसंद चुनें",
    catHair: "हेयर स्टाइलिंग",
    catSkin: "स्क्रीन व फेशियल",
    catBridal: "ब्राइडल लुक",
    catSpa: "स्पा व वेलनेस",
    explore: "एक्सप्लोर →",
    ourAtelier: "हमारा एटलियर",
    quietLuxA: "शांत विलासिता,",
    quietLuxB: "देखभाल के साथ।",
    quietLuxBody: "हर कुर्सी निजी। हर अपॉइंटमेंट इत्मीनान से। लंदन, मुंबई और टोक्यो में प्रशिक्षित — हमारी टीम वैश्विक महारत वडोदरा लाती है।",
    exploreAll: "सभी सेवाएँ देखें",
    bestSellers: "एमिनेंस बेस्ट सेलर्स",
    bestSellersSub: "सैलून-ग्रेड ब्यूटी एसेंशियल्स, हमारी टीम द्वारा चुने गए।",
    viewAllProducts: "सभी उत्पाद देखें",
    signatureServices: "सिग्नेचर सेवाएँ",
    craftedForYou: "ख़ास आपके लिए।",
    trustedByYou: "महिलाओं का भरोसा",
    trustEasyBooking: "आसान बुकिंग",
    trustEasyBookingSub: "60 सेकंड में पुष्टि करें",
    trustWorldwide: "विश्वव्यापी उत्पाद",
    trustWorldwideSub: "पूरे भारत में डिलीवरी",
    trustWA: "व्हाट्सऐप सहायता",
    trustWASub: "विशेषज्ञ मार्गदर्शन",
    trustSince: "2019 से भरोसेमंद",
    trustSinceSub: "8,000+ खुश ग्राहक",
    whyOverline: "एमिनेंस क्यों",
    whyTitle: "सुंदरता, बिना जल्दबाज़ी के।",
    whyP1: "असली समस्याओं का समाधान — सिर्फ़ छिपावा नहीं।",
    whyP2: "पूरे दिन आराम — आत्मविश्वास जो टिके।",
    whyP3: "नैतिक रूप से सोर्स किए गए, गुणवत्ता-चयनित उत्पाद।",
    whyP4: "उन महिलाओं के लिए जो गरिमा, समय और प्राकृतिक सुंदरता को महत्व देती हैं।",
    ourValues: "हमारे मूल्य",
    welcome: "स्वागत है",
    signInTitle: "साइन इन करें",
    email: "ईमेल",
    password: "पासवर्ड",
    newToEminence: "नए हैं?",
    createAccount: "खाता बनाएँ",
    haveAccount: "पहले से खाता है?",
    fullName: "पूरा नाम",
    productName: "उत्पाद का नाम",
    phone: "फ़ोन",
    reserve: "आरक्षित करें",
    bookYourAppointment: "अपॉइंटमेंट बुक करें",
    service: "सेवा",
    stylist: "स्टाइलिस्ट (वैकल्पिक)",
    anyAvailable: "कोई भी उपलब्ध",
    selectService: "सेवा चुनें —",
    date: "तारीख़",
    time: "समय",
    notes: "नोट्स (वैकल्पिक)",
    summary: "सारांश",
    duration: "अवधि",
    total: "कुल",
    confirmBooking: "बुकिंग की पुष्टि करें",
    confirming: "पुष्टि हो रही है…",
    payAtSalon: "सैलून में भुगतान। 4 घंटे पहले तक मुफ्त रद्दीकरण।",
    apothecary: "अपोथेकरी",
    eminenceShop: "एमिनेंस शॉप",
    shopSub: "सैलून-ग्रेड ब्यूटी एसेंशियल्स, हमारी टीम द्वारा चुने गए।",
    searchProducts: "उत्पाद खोजें…",
    noProducts: "कोई उत्पाद नहीं मिला।",
    quickBuy: "जल्दी ख़रीदें",
    addToCart: "कार्ट में जोड़ें",
    yourBag: "आपका बैग",
    nothingHere: "अभी कुछ नहीं है।",
    browseShop: "शॉप देखें",
    subtotal: "उप-योग",
    shipping: "शिपिंग",
    free: "मुफ़्त",
    checkout: "ચેકઆઉટ",
    placeOrder: "ऑर्डर दें",
    placing: "ऑर्डर हो रहा है…",
    accountWelcome: "स्वागत है",
    manageAppts: "अपॉइंटमेंट, ऑर्डर और विवरण प्रबंधित करें।",
    bookings: "बुकिंग",
    orders: "ऑर्डर",
    profile: "प्रोफ़ाइल",
    noBookings: "अभी कोई बुकिंग नहीं।",
    noOrders: "अभी कोई ऑर्डर नहीं।",
    explore_label: "एक्सप्लोर",
    visit: "विज़िट करें",
    hours: "समय",
    customerCare: "कस्टमर केयर",
    return14: "उत्पादों पर 14-दिन की आसान वापसी",
    // Experience Centers
    ourLocations: "हमारे स्थान",
    expCenters: "एमिनेंस एक्सपीरियंस सेंटर्स",
    expCentersSub: "हमारे विशेषज्ञ स्टाइलिस्टों के साथ व्यक्तिगत परामर्श के लिए हमसे मिलें।",
    getDirections: "रास्ता देखें",
    contact: "संपર્ક करें",
    whatsapp: "व्हाट्सऐप",
    experienceCenter: "एक्सपीरियंस सेंटर",
    // Landing Page
    tagline: "10+ वर्षों का शिल्प · बाल · त्वचा · ब्राइडल · स्पा · क्यूरेटेड अपोथेकरी ·",
    ourCollection: "हमारा संग्रह",
    exploreCollection: "संग्रह देखें",
    bestSeller: "बेસ્ટ સેલર",
    quickView: "त्वरित दर्शन",
    viewCollection: "पूरा संग्रह देखें",
    clientExp: "ग्राहकों के अनुभव",
    whatTheySay: "एमिनेंस के बारे में क्या कहते हैं",
    commonQueries: "सामान्य प्रश्न",
    frequentlyAsked: "अक्सर पूछे जाने वाले प्रश्न",
    // FAQ
    faq1q: "मैं अपॉइंटमेंट कैसे बुक कर सकता हूँ?",
    faq1a: "आप हेडर में हमारे 'बुक अपॉइंटमेंट' बटन के माध्यम से सीधे बुक कर सकते हैं, या तत्काल पुष्टि के लिए हमें व्हाट्सएप पर संदेश भेज सकते हैं।",
    faq2q: "आप किस प्रकार के हेयर एक्सटेंशन में विशेषज्ञ हैं?",
    faq2a: "हम 100% मानव बाल एक्सटेंशन में विशेषज्ञ हैं जिनमें क्लिप-इन्स, बन्स, साइड पैच और हमारे विशेषज्ञों द्वारा क्यूरेट किए गए स्थायी एक्सटेंशन शामिल हैं।",
    faq3q: "क्या आप ब्राइडल और इवेंट स्टाइलिंग प्रदान करते हैं?",
    faq3a: "हाँ, हमारे पास समर्पित ब्राइडल सुइट्स और वरिष्ठ कलाकार हैं जो हाई-एंड ब्राइडल ट्रांसफॉर्मेशन और इवेंट स्टाइलिंग में विशेषज्ञ हैं।",
    faq4q: "क्या कोई लॉयल्टी प्रोग्राम है?",
    faq4a: "बिल्कुल! एमिनेंस में हर खरीदारी और सेवा आपको लॉयल्टी पॉइंट दिलाती है जिन्हें भविष्य की बुकिंग और अपोथेकरी उत्पादों के लिए भुनाया जा सकता है।",
    faq5q: "आपके एक्सपीरियंस सेंटर कहाँ स्थित हैं?",
    faq5a: "हम वर्तमान में वडोदरा के प्रमुख केंद्रों में स्थित हैं। आप ऊपर 'एक्सपीरियंस सेंटर' अनुभाग में हमारे सटीक स्थान पा सकते हैं।",
    // Product Detail
    specifications: "विशेष विवरण",
    shippingReturns: "शिपिंग और रिटर्न",
    description: "विवरण",
    material: "सामग्री",
    style: "शैली",
    durability: "स्थायित्व",
    premiumHair: "100% प्रीमियम मानव बाल",
    salonFinish: "सैलून-ग्रेड फिनिश",
    longLasting: "उचित देखभाल के साथ लंबे समय तक चलने वाला",
    freeShipIndia: "₹999 से अधिक के ऑर्डर पर पूरे भारत में मुफ्त शिपिंग का आनंद लें। हमारा मानक वितरण समय 3-5 कार्य दिवस है।",
    hygienePolicy: "स्वच्छता कारणों से, हेयर एक्सटेंशन केवल तभी वापसी के पात्र हैं जब सील अखंड रहे और पैकेजिंग अपनी मूल स्थिति में हो।",
    guestReviews: "अतिथि समीक्षाएँ",
    writeReview: "समीक्षा लिखें",
    rating: "रेटिंग",
    comment: "टिप्पणी",
    postReview: "समीक्षा पोस्ट करें",
    posting: "पोस्ट हो रहा है...",
    noReviews: "अभी तक कोई समीक्षा नहीं। अपना अनुभव साझा करने वाले पहले व्यक्ति बनें।",
    mrp: "एमआरपी",
    qty: "मात्रा",
    units: "इकाइयाँ",
    stock: "स्टॉक",
    delivery: "डिलिवरी",
    selectColor: "रंग चुनें",
    // Services
    servicesRituals: "सेवाएँ और अनुष्ठान",
    servicesSub: "सटीक कट्स से लेकर ब्राइडल पलों तक — हर सेवा आपके लिए तैयार की गई है।",
    theTeam: "टीम",
    ourArtisans: "हमारे कारीगर",
    portfolioGallery: "पोर्टफोलियो गैलरी",
    portfolioSoon: "पोर्टफोलियो जल्द आ रहा है...",
    min: "मिनट",
    from: "से",
    // Checkout
    orderPlaced: "ऑर्डर सफल!",
    orderConfirmed: "धन्यवाद, {name}। आपका ऑर्डर #{id} पुष्ट हो गया है।",
    downloadInvoice: "इनवॉइस डाउनलोड करें",
    viewOrders: "मेरे ऑर्डर देखें",
    finalTouch: "अंतिम विवरण",
    address: "पता",
    city: "शहर",
    pincode: "पिनकोड",
    loyaltyRewards: "लॉयल्टी पॉइंट्स पुरस्कार",
    currentBalance: "वर्तमान शेष:",
    points: "पॉइंट्स",
    worth: "मूल्य",
    shopToEarn: "अधिक कमाने के लिए खरीदारी करें!",
    loginToUsePoints: "पॉइंट्स का उपयोग करने के लिए लॉगिन करें",
    pointsApplied: "पॉइंट्स लागू",
    usePoints: "पॉइंट्स का उपयोग करें",
    noPoints: "कोई पॉइंट्स उपलब्ध नहीं",
    codNotice: "डिलीवरी पर भुगतान (सीओडी)। सभी कीमतों में कर शामिल हैं।",
    orderSummary: "ऑर्डर सारांश",
    pointsDiscount: "पॉइंट्स छूट",
    pointsEarned: "इस ऑर्डर पर अर्जित पॉइंट्स",
    // Dashboard
    yourLoyalty: "आपके लॉयल्टी पॉइंट्स",
    pointsUsed: "पॉइंट्स उपयोग किए गए",
    pointsEarnedShort: "पॉइंट्स अर्जित",
    invoice: "इनवॉइस",
    role: "भૂમિકा",
    currentPoints: "वर्तमान पॉइंट्स",
    notProvided: "प्रदान नहीं किया गया",
    order: "ऑर्डर",
    // Admin
    operations: "ऑपरेशंस",
    adminDashboard: "एडमिन डैशबोर्ड",
    adminSub: "एमिनेंस का संपूर्ण प्रबंधन।",
    overview: "अवलोकन",
    enquiries: "पूछताछ",
    users: "उपयोगकर्ता",
    customer: "ग्राहक",
    status: "स्थिति",
    category: "श्रेणी",
    stock_label: "वॉल्यूम",
    mainImg: "मुख्य छवि URL",
    videoUrl: "वीडियो URL",
    extraImages: "अतिरिक्त छवियाँ (कोमा से अलग)",
    client: "क्लाइंट",
    concern: "चिंता",
    joined: "शामिल हुए",
    revenue: "राजस्व",
    recentOrders: "हाल के ऑर्डर",
    noRecords: "कोई रिकॉर्ड नहीं।",
    edit: "संपादित करें",
    add: "जोड़ें",
    create: "बनाएँ",
    update: "अपडेट करें",
    deleteConfirm: "हटाएं?",
    deleted: "हटा दिया गया",
    saveFailed: "सहेजने में विफल",
    product: "उत्पाद",
    // Footer
    footerPitch: "एक प्रीमियम सैलून और क्यूरेटेड ब्यूटी स्टोर। भारतीय आतिथ્ય की गर्माहट के साथ आधुनिक तकनीक।",
    shopProducts: "उत्पाद खरीदें",
    myAccount: "मेरा खाता",
    weekdays: "सोम — शनि · 10:00 – 21:00",
    sunday: "रविवार · 11:00 – 19:00",
    rights: "© 2026 एमिनेंस सैलून वडोદरा। सर्वाधिकार सुरक्षित।",
    buildBy: "द्वारा निर्मित",
    all: "सभी",
    chooseServiceError: "कृपया सेवा, तिथि और समय चुनें।",
    bookSuccess: "अपॉइंटमेंट की पुष्टि हो गई।",
    notesPlaceholder: "एलर्जी, प्राथमिकताएं, अवसर…",
    welcomeBack: "वापसी पर स्वागत है, {name}।",
    demoCreds: "डेमो क्रेडेंशियल",
    joinEminence: "एमिनेंस से जुड़ें",
    regSuccess: "खाता सफलतापूर्वक बनाया गया!",
    mensSection: "आधुनिक पुरुष",
    mensGrooming: "पुरुषों की ग्रूमिंग",
    hairSystems: "हेयर सिस्टम",
    mensShop: "पुरुषों के लिए शॉप",
    mensGroomingSub: "सटीक कट्स, दाढ़ी स्टाइलिंग, और हेयर रेस्टोरेशन।",
    men: "पुरुष",
    women: "महिलाएं",
    accessories: "एक्सेसरीज",
    accessoriesSection: "अपना लुक पूरा करें",
    accessoriesShop: "एक्सेसरीज शॉप",
    accessoriesSub: "प्रीमियम हेयर एक्सेसरीज और केयर एसेंशियल के साथ अपनी शैली को ऊंचा करें।",
    targetAudience: "लक्षित दर्शक",
    essentials: "अनिवार्य",
    // Men Page
    menPageHeroOverline: "गैर-सर्जिकल हेयर रिप्लेसमेंट",
    menPageHeroTitle: "आत्मविश्वास की वापसी।",
    menPageHeroSub: "आधुनिक पुरुषों के लिए डिज़ाइन किए गए प्रीमियम हेयर सिस्टम। पूरी तरह से प्राकृतिक लुक के लिए निर्मित।",
    menWhyTitle: "एमिनेंस हेयर सिस्टम क्यों चुनें?",
    menWhySub: "हम केवल हेयर पैच प्रदान नहीं करते हैं; हम जीवन पर एक नया दृष्टिकोण प्रदान करते हैं।",
    menFeature1Title: "100% असली बाल",
    menFeature1Sub: "सही टेक्सचर और मूवमेंट के लिए उच्चतम गुणवत्ता वाले प्राकृतिक बाल।",
    menFeature2Title: "अदृश्य बेस",
    menFeature2Sub: "अल्ट्रा-थिन सामग्री जो आपके स्कैल्प के साथ सहजता से मिल जाती है।",
    menFeature3Title: "सक्रिय जीवनशैली",
    menFeature3Sub: "पूरे आत्मविश्वास के साथ तैरें, जिम जाएं और नहाएं।",
    menSystemsTitle: "हमारे हेयर सिस्टम",
    menSystemLaceTitle: "फ्रेंच लेस सिस्टम",
    menSystemLaceSub: "सबसे सांस लेने योग्य और प्राकृतिक दिखने वाला बेस, गर्म जलवायु के लिए उपयुक्त।",
    menSystemSilkTitle: "सिल्क टॉप सिस्टम",
    menSystemSilkSub: "सबसे यथार्थवादी 'स्कैल्प' लुक। बाल ऐसे दिखते हैं जैसे वे आपके सिर से उग रहे हों।",
    menSystemMonoTitle: "मोनोफिलामेंट सिस्टम",
    menSystemMonoSub: "लंबे समय तक चलने वाला विकल्प, आसान रखरखाव के लिए डिज़ाइन किया गया।",
    menProcessTitle: "परिवर्तन की यात्रा",
    menStep1Title: "परामर्श",
    menStep1Sub: "हम आपके बालों के झड़ने के पैटर्न और स्कैल्प के प्रकार का विश्लेषण करते हैं।",
    menStep2Title: "कस्टम मैपिंग",
    menStep2Sub: "सही फिट और प्राकृतिक हेयरलाइन सुनिश्चित करने के लिए सटीक माप।",
    menStep3Title: "फिटिंग और स्टाइलिंग",
    menStep3Sub: "हमारे मास्टर स्टाइलिस्ट आपके चेहरे के आकार के अनुसार सिस्टम को कट और ब्लेंड करते हैं।",
    menStep4Title: "अंतिम लुक",
    menStep4Sub: "पूरे सिर पर बालों और आत्मविश्वास के साथ बाहर कदम रखें।",
    menFaqTitle: "सामान्य प्रश्न",
    menFaq1Q: "क्या मैं हेयर पैच के साथ नहा सकता हूँ या तैर सकता हूँ?",
    menFaq1A: "हाँ! हमारे उच्च गुणवत्ता वाले चिपकने वाले वाटर-रेसिस्टेंट हैं। आप अपनी सक्रिय जीवनशैली आसानी से बनाए रख सकते हैं।",
    menFaq2Q: "हेयर सिस्टम कितने समय तक चलता है?",
    menFaq2A: "बेस सामग्री और रखरखाव के आधार पर, सिस्टम आमतौर पर 3 से 8 महीने तक चलते हैं।",
    menFaq3Q: "क्या लोगों को पता चल जाएगा कि मैंने हेयर पैच पहना है?",
    menFaq3A: "बिल्कुल नहीं। हमारी विशेष तकनीकें सुनिश्चित करती हैं कि हेयरलाइन पूरी तरह से अदृश्य हो।",
  },
  gu: {
    home: "હોમ",
    services: "સેવાઓ",
    book: "બુક કરો",
    bookAppointment: "એપોઈન્ટમેન્ટ બુક કરો",
    shop: "શોપ",
    signIn: "સાઇન ઇન",
    signOut: "લૉગઆઉટ",
    account: "મારું ખાતું",
    admin: "એડમિન",
    salesPanel: "સેલ્સ પેનલ",
    retargeting: "રિટાર્ગેટિંગ",
    bulkMessage: "બલ્ક મેસેજ",
    cart: "કાર્ટ",
    annFreeShip: "₹999થી ઉપર સમગ્ર ભારતમાં મફત શિપિંગ",
    annTrusted: "8,000+ વડોદરાવાસીઓનો વિશ્વાસ",
    annBookOnline: "ઑનલાઇન બુક કરો · વૉક-ઇન પણ આવકાર્ય",
    annOff: "પ્રથમ મુલાકાત પર 20% છૂટ",
    heroOverline: "એમિનન્સ · વડોદરા · 2019 થી",
    heroTitleA: "એ સ્ત્રીઓ માટેનું સલૂન",
    heroTitleB: "જે સમાધાન કરતી નથી.",
    heroSub: "એડિટોરિયલ કટ. માસ્ટરફુલ કલર. ક્યુરેટેડ બ્યુટી — તમારા માટે, અલ્કાપુરીના હૃદયથી.",
    shopNow: "હમણાં ખરીદો",
    scroll: "સ્ક્રોલ",
    findYourMoment: "તમારી પળ શોધો",
    chooseRitual: "તમારી પસંદ પસંદ કરો",
    catHair: "હેર સ્ટાઇલિંગ",
    catSkin: "સ્કિન અને ફેશિયલ",
    catBridal: "બ્રાઇડલ લૂક",
    catSpa: "સ્પા અને વેલનેસ",
    explore: "એક્સપ્લોર →",
    ourAtelier: "અમારું એટલિયર",
    quietLuxA: "શાંત વૈભવ,",
    quietLuxB: "કાળજી સાથે.",
    quietLuxBody: "દરેક ખુરશી ખાનગી. દરેક એપોઈન્ટમેન્ટ આરામથી. લંડન, મુંબઈ અને ટોક્યોમાં તાલીમ પામેલ — અમારી ટીમ વૈશ્વિક નિપુણતા વડોદરા લાવે છે.",
    exploreAll: "બધી સેવાઓ જુઓ",
    bestSellers: "એમિનન્સ બેસ્ટ સેલર્સ",
    bestSellersSub: "સલૂન-ગ્રેડ બ્યુટી એસેન્શિયલ્સ, અમારી ટીમ દ્વારા પસંદ કરેલ.",
    viewAllProducts: "બધા ઉત્પાદનો જુઓ",
    signatureServices: "સિગ્નેચર સેવાઓ",
    craftedForYou: "ખાસ તમારા માટે.",
    trustedByYou: "સ્ત્રીઓનો વિશ્વાસ",
    trustEasyBooking: "સરળ બુકિંગ",
    trustEasyBookingSub: "60 સેકન્ડમાં પુષ્ટિ",
    trustWorldwide: "વિશ્વભરના ઉત્પાદનો",
    trustWorldwideSub: "સમગ્ર ભારતમાં શિપિંગ",
    trustWA: "વ્હોટ્સએપ સહાય",
    trustWASub: "નિષ્ણાત માર્ગદર્શન",
    trustSince: "2019 થી વિશ્વસનીય",
    trustSinceSub: "8,000+ ખુશ ગ્રાહકો",
    whyOverline: "એમિનન્સ શા માટે",
    whyTitle: "સુંદરતા — ઉતાવળ વિના.",
    whyP1: "અસલી સમસ્યાઓનું સમાધાન, માત્ર ઢાંકપિછોડો નહીં.",
    whyP2: "આખા દિવસનો આરામ — આત્મવિશ્વાસ જે ટકે છે.",
    whyP3: "નૈતિક રીતે મેળવેલા, ગુણવત્તા-પસંદગી પ્રોડક્ટ્સ.",
    whyP4: "ગૌરવ, સમય અને કુદરતી સુંદરતાને મૂલ્ય આપતી સ્ત્રીઓ માટે.",
    ourValues: "અમારા મૂલ્યો",
    welcome: "આવકાર",
    signInTitle: "સાઇન ઇન",
    email: "ઇમેઇલ",
    password: "પાસવર્ડ",
    newToEminence: "નવા છો?",
    createAccount: "ખાતું બનાવો",
    haveAccount: "પહેલેથી ખાતું છે?",
    fullName: "પૂરું નામ",
    productName: "ઉત્પાદન નામ",
    phone: "ફોન",
    reserve: "આરક્ષિત કરો",
    bookYourAppointment: "એપોઈન્ટમેન્ટ બુક કરો",
    service: "સેવા",
    stylist: "સ્ટાઈલિસ્ટ (વૈકલ્પિક)",
    anyAvailable: "કોઈ પણ ઉપલબ્ધ",
    selectService: "સેવા પસંદ કરો —",
    date: "તારીખ",
    time: "સમય",
    notes: "નોંધ (વૈકલ્પિક)",
    summary: "સારાંશ",
    duration: "અવધિ",
    total: "કુલ",
    confirmBooking: "બુકિંગ પુષ્ટિ કરો",
    confirming: "પુષ્ટિ થાય છે…",
    payAtSalon: "સલૂનમાં ચુકવણી. 4 કલાક પહેલાં મફત રદ.",
    apothecary: "અપોથેકરી",
    eminenceShop: "ધ એમિનન્સ શોપ",
    shopSub: "સલૂન-ગ્રેડ બ્યુટી એસેન્શિયલ્સ, અમારી ટીમ દ્વારા પસંદ કરેલ.",
    searchProducts: "ઉત્પાદનો શોધો…",
    noProducts: "કોઈ ઉત્પાદન મળ્યું નહીં.",
    quickBuy: "ઝડપી ખરીદી",
    addToCart: "કાર્ટમાં ઉમેરો",
    yourBag: "તમારી બેગ",
    nothingHere: "હજી કંઈ નથી.",
    browseShop: "શોપ જુઓ",
    subtotal: "પેટા-યોગ",
    shipping: "શિપિંગ",
    free: "મફત",
    checkout: "ચેકઆઉટ",
    placeOrder: "ઑર્ડર આપો",
    placing: "ઑર્ડર થાય છે…",
    accountWelcome: "આવકાર",
    manageAppts: "એપોઈન્ટમેન્ટ, ઓર્ડર અને વિગતો સંચાલિત કરો.",
    bookings: "બુકિંગ",
    orders: "ઑર્ડર",
    profile: "પ્રોફાઇલ",
    noBookings: "હજી કોઈ બુકિંગ નથી.",
    noOrders: "હજી કોઈ ઑર્ડર નથી.",
    explore_label: "એક્સપ્લોર",
    visit: "મુલાકાત",
    hours: "સમય",
    customerCare: "ગ્રાહક સંભાળ",
    return14: "ઉત્પાદનો પર 14-દિવસ સરળ વળતર",
    // Experience Centers
    ourLocations: "અમારા સ્થાનો",
    expCenters: "એમિનન્સ એક્સપિરિયન્સ સેન્ટર્સ",
    expCentersSub: "અમારા નિષ્ણાત સ્ટાઇલિસ્ટ સાથે વ્યક્તિગત પરામર્શ માટે અમારી મુલાકાત લો.",
    getDirections: "રસ્તો જુઓ",
    contact: "સંપર્ક",
    whatsapp: "વ્હોટ્સએપ",
    experienceCenter: "એક્સપિરિયન્સ સેન્ટર",
    // Landing Page
    tagline: "10+ વર્ષની કારીગરી · વાળ · ત્વચા · બ્રાઇડલ · સ્પા · ક્યુરેટેડ અપોથેકરી ·",
    ourCollection: "અમારું કલેક્શન",
    exploreCollection: "કલેક્શન જુઓ",
    bestSeller: "બેસ્ટ સેલર",
    quickView: "ઝડપી વ્યૂ",
    viewCollection: "પૂરું કલેક્શન જુઓ",
    clientExp: "ગ્રાહકોના અનુભવો",
    whatTheySay: "એમિનન્સ વિશે તેઓ શું કહે છે",
    commonQueries: "સામાન્ય પ્રશ્નો",
    frequentlyAsked: "વારંવાર પૂછાતા પ્રશ્નો",
    // FAQ
    faq1q: "હું એપોઈન્ટમેન્ટ કેવી રીતે બુક કરી શકું?",
    faq1a: "તમે હેડરમાં અમારા 'બુક એપોઈન્ટમેન્ટ' બટન દ્વારા સીધા જ બુક કરી શકો છો, અથવા ત્વરિત પુષ્ટિ માટે અમને વોટ્સએપ પર મેસેજ કરી શકો છો.",
    faq2q: "તમે કયા પ્રકારના હેર એક્સટેન્શનમાં નિષ્ણાત છો?",
    faq2a: "અમે 100% હ્યુમન હેર એક્સટેન્શનમાં નિષ્ણાત છીએ જેમાં ક્લિપ-ઈન્સ, બન્સ, સાઈડ પેચ અને અમારા નિષ્ણાતો દ્વારા ક્યુરેટ કરાયેલ કાયમી એક્સટેન્શનનો સમાવેશ થાય છે.",
    faq3q: "શું તમે બ્રાઇડલ અને ઇવેન્ટ સ્ટાઇલિંગ ઓફર કરો છો?",
    faq3a: "હા, અમારી પાસે સમર્પિત બ્રાઇડલ સ્યુટ્સ અને વરિષ્ઠ કલાકારો છે જે હાઈ-એન્ડ બ્રાઇડલ ટ્રાન્સફોર્મેશન અને ઇવેન્ટ સ્ટાઇલિંગમાં નિષ્ણાત છે.",
    faq4q: "શું કોઈ લોયલ્ટી પ્રોગ્રામ છે?",
    faq4a: "ચોક્કસ! એમિનન્સમાં દરેક ખરીદી અને સેવા તમને લોયલ્ટી પોઈન્ટ્સ કમાવી આપે છે જેને ભવિષ્યના બુકિંગ અને અપોથેકરી ઉત્પાદનો માટે રિડીમ કરી શકાય છે.",
    faq5q: "તમારા એક્સપિરિયન્સ સેન્ટર ક્યાં આવેલા છે?",
    faq5a: "અમે અત્યારે વડોદરાના મુખ્ય હબમાં આવેલા છીએ. તમે ઉપર 'એક્સપિરિયન્સ સેન્ટર' વિભાગમાં અમારા ચોક્કસ સ્થાનો શોધી શકો છો.",
    // Product Detail
    specifications: "વિશેષ વિગતો",
    shippingReturns: "શિપિંગ અને રિટર્ન",
    description: "વર્ણન",
    material: "સામગ્રી",
    style: "શૈલી",
    durability: "ટકાઉપણું",
    premiumHair: "100% પ્રીમિયમ હ્યુમન હેર",
    salonFinish: "સલૂન-ગ્રેડ ફિનિશ",
    longLasting: "યોગ્ય કાળજી સાથે લાંબા સમય સુધી ચાલે તેવું",
    freeShipIndia: "₹999થી વધુના ઓર્ડર પર સમગ્ર ભારતમાં મફત શિપિંગનો આનંદ માણો. અમારો પ્રમાણભૂત વિતરણ સમય 3-5 કામકાજના દિવસો છે.",
    hygienePolicy: "સ્વચ્છતાના કારણોસર, હેર એક્સટેન્શન ફક્ત ત્યારે જ પરત કરવા પાત્ર છે જો સીલ અકબંધ રહે અને પેકેજિંગ તેની મૂળ સ્થિતિમાં હોય.",
    guestReviews: "અતિથિ સમીક્ષાઓ",
    writeReview: "સમીક્ષા લખો",
    rating: "રેટિંગ",
    comment: "ટિપ્પણી",
    postReview: "સમીક્ષા પોસ્ટ કરો",
    posting: "પોસ્ટ થાય છે...",
    noReviews: "હજી સુધી કોઈ સમીક્ષા નથી. તમારો અનુભવ શેર કરનાર પ્રથમ બનો.",
    mrp: "MRP",
    qty: "જથ્થો",
    units: "એકમો",
    stock: "સ્ટોક",
    delivery: "ડિલિવરી",
    selectColor: "રંગ પસંદ કરો",
    // Services
    servicesRituals: "સેવાઓ અને ધાર્મિક વિધિઓ",
    servicesSub: "પ્રિસિઝન કટ્સથી લઈને બ્રાઇડલ પળો સુધી — દરેક સેવા તમારા માટે તૈયાર કરવામાં આવી છે.",
    theTeam: "ટીમ",
    ourArtisans: "અમારા કારીગરો",
    portfolioGallery: "પોર્ટફોલિયો ગેલેરી",
    portfolioSoon: "પોર્ટફોલિયો ટૂંક સમયમાં આવી રહ્યો છે...",
    min: "મિનિટ",
    from: "થી",
    // Checkout
    orderPlaced: "ઑર્ડર સફળ!",
    orderConfirmed: "આભાર, {name}. તમારો ઑર્ડર #{id} પુષ્ટિ થયેલ છે.",
    downloadInvoice: "ઇન્વોઇસ ડાઉનલોડ કરો",
    viewOrders: "મારા ઑર્ડર જુઓ",
    finalTouch: "અંતિમ વિગતો",
    address: "સરનામું",
    city: "શહેર",
    pincode: "પિનકોડ",
    loyaltyRewards: "લોયલ્ટી પોઈન્ટ્સ રિવોર્ડ્સ",
    currentBalance: "વર્તમાન બેલેન્સ:",
    points: "પોઈન્ટ્સ",
    worth: "મૂલ્ય",
    shopToEarn: "વધારે કમાવવા માટે ખરીદી કરો!",
    loginToUsePoints: "પોઈન્ટ્સ વાપરવા માટે લોગિન કરો",
    pointsApplied: "પોઈન્ટ્સ લાગુ",
    usePoints: "પોઈન્ટ્સ વાપરો",
    noPoints: "કોઈ પોઈન્ટ્સ ઉપલબ્ધ નથી",
    codNotice: "ડિલિવરી પર ચુકવણી (COD). તમામ કિંમતોમાં ટેક્સ સામેલ છે.",
    orderSummary: "ઑર્ડર સારાંશ",
    pointsDiscount: "પોઈન્ટ્સ ડિસ્કાઉન્ટ",
    pointsEarned: "આ ઑર્ડર પર કમાયેલા પોઈન્ટ્સ",
    // Dashboard
    yourLoyalty: "તમારા લોયલ્ટી પોઈન્ટ્સ",
    pointsUsed: "વપરાયેલ પોઈન્ટ્સ",
    pointsEarnedShort: "મેળવેલ પોઈન્ટ્સ",
    invoice: "ઇન્વોઇસ",
    role: "ભૂમિકા",
    currentPoints: "વર્તમાન પોઈન્ટ્સ",
    notProvided: "આપેલ નથી",
    order: "ઑર્ડર",
    // Admin
    operations: "ઓપરેશન્સ",
    adminDashboard: "એડમિન ડેશબોર્ડ",
    adminSub: "એમિનન્સનું સંપૂર્ણ સંચાલન.",
    overview: "ઝાંખી",
    enquiries: "પૂછપરછ",
    users: "વપરાશકર્તાઓ",
    customer: "ગ્રાહક",
    status: "સ્થિતિ",
    category: "શ્રેણી",
    stock_label: "વોલ્યુમ",
    mainImg: "મુખ્ય છબી URL",
    videoUrl: "વીડિયો URL",
    extraImages: "વધારાની છબીઓ (કોમાથી અલગ)",
    client: "ક્લાયન્ટ",
    concern: "ચિંતા",
    joined: "જોડાયા",
    revenue: "મહેસૂલ",
    recentOrders: "તાજેતરના ઓર્ડર",
    noRecords: "કોઈ રેકોર્ડ નથી.",
    edit: "ફેરફાર કરો",
    add: "ઉમેરો",
    create: "બનાવો",
    update: "અપડેટ કરો",
    deleteConfirm: "કાઢી નાખવું?",
    deleted: "કાઢી નાખ્યું",
    saveFailed: "સાચવવામાં નિષ્ફળ",
    product: "ઉત્પાદન",
    // Footer
    footerPitch: "એક પ્રીમિયમ સલૂન અને ક્યુરેટેડ બ્યુટી સ્ટોર. ભારતીય આતિથ્યની હૂંફ સાથે આધુનિક ટેકનિક.",
    shopProducts: "પ્રોડક્ટ્સ ખરીદો",
    myAccount: "મારું ખાતું",
    weekdays: "સોમ — શનિ · 10:00 – 21:00",
    sunday: "રવિવાર · 11:00 – 19:00",
    rights: "© 2026 એમિનન્સ સલૂન વડોદરા. તમામ હકો સ્વાધીન.",
    buildBy: "દ્વારા નિર્મિત",
    all: "બધા",
    chooseServiceError: "કૃપા કરીને સેવા, તારીખ અને સમય પસંદ કરો.",
    bookSuccess: "એપોઈન્ટમેન્ટ કન્ફર્મ થઈ ગઈ.",
    notesPlaceholder: "એલર્જી, પસંદગીઓ, પ્રસંગ…",
    welcomeBack: "ફરી સ્વાગત છે, {name}.",
    demoCreds: "ડેમો ઓળખપત્ર",
    joinEminence: "એમિનન્સમાં જોડાઓ",
    regSuccess: "ખાતું સફળતાપૂર્વક બનાવવામાં આવ્યું!",
    mensSection: "આધુનિક પુરુષ",
    mensGrooming: "પુરુષોની ગ્રૂમિંગ",
    hairSystems: "હેર સિસ્ટમ",
    mensShop: "પુરુષો માટે શોપ",
    mensGroomingSub: "પ્રિસિઝન કટ્સ, દાઢી સ્ટાઇલિંગ અને હેર રિસ્ટોરેશન.",
    men: "પુરુષ",
    women: "મહિલાઓ",
    accessories: "એક્સેસરીઝ",
    accessoriesSection: "તમારો લૂક પૂરો કરો",
    accessoriesShop: "એક્સેસરીઝ શોપ",
    accessoriesSub: "પ્રીમિયમ હેર એક્સેસરીઝ અને કેર એસેન્શિયલ્સ સાથે તમારી શૈલીને વધુ નિખારો.",
    targetAudience: "લક્ષિત પ્રેક્ષકો",
    essentials: "આવશ્યક વસ્તુઓ",
    // Men Page
    menPageHeroOverline: "નોન-સર્જિકલ હેર રિપ્લેસમેન્ટ",
    menPageHeroTitle: "આત્મવિશ્વાસની પુનઃપ્રાપ્તિ.",
    menPageHeroSub: "આધુનિક પુરુષો માટે ખાસ ડિઝાઇન કરેલ પ્રીમિયમ હેર સિસ્ટમ્સ. અદ્રશ્ય અને ટકાઉ.",
    menWhyTitle: "એમિનન્સ હેર સિસ્ટમ્સ શા માટે પસંદ કરવી?",
    menWhySub: "અમે માત્ર હેર પેચ નથી આપતા; અમે જીવન પ્રત્યેનો નવો દ્રષ્ટિકોણ આપીએ છીએ.",
    menFeature1Title: "100% હ્યુમન હેર",
    menFeature1Sub: "પરફેક્ટ ટેક્સચર અને મૂવમેન્ટ માટે ઉચ્ચ ગુણવત્તાના કુદરતી વાળ.",
    menFeature2Title: "અદ્રશ્ય બેઝ",
    menFeature2Sub: "અલ્ટ્રા-થિન સામગ્રી જે તમારા સ્કાલ્પ સાથે ભળી જાય છે.",
    menFeature3Title: "એક્ટિવ લાઇફસ્ટાઇલ",
    menFeature3Sub: "સંપૂર્ણ આત્મવિશ્વાસ સાથે સ્વિમિંગ અને જિમ કરો.",
    menSystemsTitle: "અમારી હેર સિસ્ટમ્સ",
    menSystemLaceTitle: "ફ્રેન્ચ લેસ સિસ્ટમ",
    menSystemLaceSub: "સૌથી વધુ બ્રીધેબલ અને કુદરતી દેખાતો બેઝ, ગરમ આબોહવા માટે યોગ્ય.",
    menSystemSilkTitle: "સિલ્ક ટોપ સિસ્ટમ",
    menSystemSilkSub: "સૌથી વાસ્તવિક 'સ્કાલ્પ' લૂક. વાળ માથામાંથી જ ઊગી રહ્યા હોય તેવું લાગે છે.",
    menSystemMonoTitle: "મોનોફિલામેન્ટ સિસ્ટમ",
    menSystemMonoSub: "સૌથી ટકાઉ વિકલ્પ, લાંબા સમય સુધી ચાલવા અને સરળ જાળવણી માટે.",
    menProcessTitle: "પરિવર્તનની સફર",
    menStep1Title: "પરામર્શ",
    menStep1Sub: "અમે તમારા વાળ ખરવાની પેટર્ન અને સ્કાલ્પ પ્રકારનું વિશ્લેષણ કરીએ છીએ.",
    menStep2Title: "કસ્ટમ મેપિંગ",
    menStep2Sub: "પરફેક્ટ ફિટ અને કુદરતી હેરલાઇન સુનિશ્ચિત કરવા માટે ચોક્કસ માપ.",
    menStep3Title: "ફિટિંગ અને સ્ટાઇલિંગ",
    menStep3Sub: "અમારા માસ્ટર સ્ટાઈલિસ્ટ તમારા ચહેરાના આકાર મુજબ સિસ્ટમને કટ અને બ્લેન્ડ કરે છે.",
    menStep4Title: "અંતિમ દેખાવ",
    menStep4Sub: "નવા આત્મવિશ્વાસ સાથે બહાર ડગ માંડો.",
    menFaqTitle: "સામાન્ય પ્રશ્નો",
    menFaq1Q: "શું હું હેર પેચ સાથે સ્નાન કરી શકું કે સ્વિમિંગ કરી શકું?",
    menFaq1A: "હા! અમારા ઉચ્ચ ગુણવત્તાના એડહેસિવ્સ વોટર-રેઝિસ્ટન્ટ છે. તમે તમારી એક્ટિવ લાઇફસ્ટાઇલ સરળતાથી જાળવી શકો છો.",
    menFaq2Q: "હેર સિસ્ટમ કેટલો સમય ચાલે છે?",
    menFaq2A: "સામગ્રી અને જાળવણીના આધારે, સિસ્ટમ સામાન્ય રીતે 3 થી 8 મહિના સુધી ચાલે છે.",
    menFaq3Q: "શું લોકોને ખબર પડશે કે મેં હેર પેચ પહેર્યો છે?",
    menFaq3A: "બિલકુલ નહીં. અમારી વિશિષ્ટ તકનીકો હેરલાઇનને સંપૂર્ણપણે અદ્રશ્ય રાખે છે.",
  },
};
